/* Cobra Coldres — calculadora de frete na PDP.
   Resolve UF via ViaCEP (público) e mostra PAC/SEDEX + prazo usando a MESMA tabela das
   zonas configuradas no Shopify. Só estima na página — NÃO guarda o CEP (sem localStorage
   nem atributo de carrinho); o handoff ao checkout não era possível e foi removido.
   IMPORTANTE: se mudar as zonas/preços/prazos (scripts/shopify_frete_zonas.py),
   regenerar este mapa (output/_frete-uf-map.json) e colar aqui.
   ⚠️ PISO DE R$ 300 (2026-08-27): nas zonas de brinde o PAC só é grátis a partir desse
   valor; abaixo dele vale `pacAbaixo`. Esta tabela é uma CÓPIA da configuração do
   Shopify, então ela mente se ficar desatualizada — e mentir aqui é pior que não
   calcular: a ficha diria GRÁTIS e o checkout cobraria. O preço da variante vem do
   snippet (data-frete-precos/data-frete-limite), não é adivinhado do DOM. */
(function () {
  var FRETE = {"SC":{"free":true,"pac":0,"sedex":20,"pacPrz":7,"sedexPrz":3,"pacAbaixo":15},"PR":{"free":true,"pac":0,"sedex":40,"pacPrz":8,"sedexPrz":4,"pacAbaixo":20},"RS":{"free":true,"pac":0,"sedex":40,"pacPrz":8,"sedexPrz":4,"pacAbaixo":20},"SP":{"free":true,"pac":0,"sedex":40,"pacPrz":8,"sedexPrz":4,"pacAbaixo":20},"MG":{"free":true,"pac":0,"sedex":50,"pacPrz":9,"sedexPrz":5,"pacAbaixo":25},"MS":{"free":true,"pac":0,"sedex":50,"pacPrz":10,"sedexPrz":6,"pacAbaixo":25},"RJ":{"free":true,"pac":0,"sedex":50,"pacPrz":9,"sedexPrz":5,"pacAbaixo":25},"ES":{"free":true,"pac":0,"sedex":60,"pacPrz":10,"sedexPrz":6,"pacAbaixo":40},"GO":{"free":true,"pac":0,"sedex":70,"pacPrz":10,"sedexPrz":6,"pacAbaixo":55},"DF":{"free":false,"pac":75,"sedex":120,"pacPrz":8,"sedexPrz":4},"AC":{"free":false,"pac":105,"sedex":135,"pacPrz":13,"sedexPrz":9},"AL":{"free":false,"pac":105,"sedex":135,"pacPrz":11,"sedexPrz":7},"AM":{"free":false,"pac":105,"sedex":135,"pacPrz":22,"sedexPrz":7},"BA":{"free":false,"pac":105,"sedex":135,"pacPrz":9,"sedexPrz":5},"CE":{"free":false,"pac":105,"sedex":135,"pacPrz":9,"sedexPrz":5},"MA":{"free":false,"pac":105,"sedex":135,"pacPrz":12,"sedexPrz":8},"MT":{"free":false,"pac":105,"sedex":135,"pacPrz":11,"sedexPrz":7},"PA":{"free":false,"pac":105,"sedex":135,"pacPrz":12,"sedexPrz":8},"PB":{"free":false,"pac":105,"sedex":135,"pacPrz":12,"sedexPrz":8},"PE":{"free":false,"pac":105,"sedex":135,"pacPrz":9,"sedexPrz":5},"RN":{"free":false,"pac":105,"sedex":135,"pacPrz":12,"sedexPrz":8},"RO":{"free":false,"pac":105,"sedex":135,"pacPrz":12,"sedexPrz":8},"RR":{"free":false,"pac":105,"sedex":135,"pacPrz":23,"sedexPrz":8},"SE":{"free":false,"pac":105,"sedex":135,"pacPrz":11,"sedexPrz":7},"TO":{"free":false,"pac":105,"sedex":135,"pacPrz":11,"sedexPrz":7},"AP":{"free":false,"pac":125,"sedex":160,"pacPrz":18,"sedexPrz":14},"PI":{"free":false,"pac":125,"sedex":160,"pacPrz":null,"sedexPrz":null}};

  function brl(v) { return v === 0 ? 'GRÁTIS' : 'R$ ' + Number(v).toFixed(2).replace('.', ','); }
  function prz(d) { return d ? 'até ' + d + ' dias úteis' : 'prazo no checkout'; }
  function maskCep(v) { v = (v || '').replace(/\D/g, '').slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; }

  /* preço da variante selecionada, em centavos (o snippet imprime o mapa) */
  function precoAtual(box) {
    var mapa;
    try { mapa = JSON.parse(box.getAttribute('data-frete-precos') || '{}'); } catch (e) { mapa = {}; }
    var ids = Object.keys(mapa);
    if (!ids.length) return null;
    var inp = document.querySelector('.product-variant-id');
    var id = inp && String(inp.value || '');
    if (id && mapa[id] != null) return Number(mapa[id]);
    /* sem variante identificada: usa o MENOR preço, que é o cenário mais conservador
       (se o menor já passa do piso, qualquer escolha passa) */
    return Math.min.apply(null, ids.map(function (k) { return Number(mapa[k]); }));
  }

  function render(box, cidade, uf) {
    var t = FRETE[uf];
    var limite = Number(box.getAttribute('data-frete-limite') || 0);
    var preco = precoAtual(box);
    var pac = t ? t.pac : 0;
    var abaixoDoPiso = !!(t && t.free && limite && preco !== null && preco < limite
                          && t.pacAbaixo != null);
    if (abaixoDoPiso) pac = t.pacAbaixo;
    var r = box.querySelector('.cobra-frete__result');
    if (!t) { r.innerHTML = '<p class="cobra-frete__erro">Não encontramos o frete para esse CEP. Tente no checkout.</p>'; return; }
    var html = '<p class="cobra-frete__cidade">Para ' + cidade + '/' + uf + ':</p>';
    html += '<div class="cobra-frete__op' + (pac === 0 ? ' cobra-frete__op--free' : '') + '"><span class="nome">Econômico (PAC)<span class="prz">' + prz(t.pacPrz) + '</span></span>'
          + '<span class="val' + (pac === 0 ? ' gratis' : '') + '">' + brl(pac) + '</span></div>';
    if (abaixoDoPiso) {
      html += '<p class="cobra-frete__piso">Frete grátis a partir de R$ '
            + (limite / 100).toFixed(0) + ' nesta região.</p>';
    }
    html += '<div class="cobra-frete__op"><span class="nome">Expresso (SEDEX)<span class="prz">' + prz(t.sedexPrz) + '</span></span>'
          + '<span class="val">' + brl(t.sedex) + '</span></div>';
    r.innerHTML = html;
  }

  function calcular(box) {
    var inp = box.querySelector('.cobra-frete__cep');
    var btn = box.querySelector('.cobra-frete__btn');
    var r = box.querySelector('.cobra-frete__result');
    var cep = (inp.value || '').replace(/\D/g, '');
    if (cep.length !== 8) { r.innerHTML = '<p class="cobra-frete__erro">Digite um CEP válido (8 dígitos).</p>'; return; }
    btn.disabled = true; r.innerHTML = '<p class="cobra-frete__cidade">Calculando…</p>';
    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (x) { return x.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d.erro || !d.uf) { r.innerHTML = '<p class="cobra-frete__erro">CEP não encontrado.</p>'; return; }
        render(box, d.localidade || '', d.uf);
      })
      .catch(function () { btn.disabled = false; r.innerHTML = '<p class="cobra-frete__erro">Não foi possível consultar agora. Tente de novo.</p>'; });
  }

  function init(box) {
    var inp = box.querySelector('.cobra-frete__cep');
    inp.addEventListener('input', function () { inp.value = maskCep(inp.value); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcular(box); } });
    box.querySelector('.cobra-frete__btn').addEventListener('click', function (e) { e.preventDefault(); calcular(box); });
    /* linha slim: abre/fecha o painel e foca o CEP ao abrir */
    var toggle = box.querySelector('.cobra-frete__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var aberto = box.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', aberto ? 'true' : 'false');
        if (aberto) setTimeout(function () { inp.focus(); }, 50);
      });
    }
  }

  function boot() {
    document.querySelectorAll('.cobra-frete').forEach(function (b) { if (!b.dataset.init) { b.dataset.init = '1'; init(b); } });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  // PDP do Dawn troca seção via JS em alguns casos — re-inicializa
  document.addEventListener('shopify:section:load', boot);
})();
